
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/subscription",
      function () {
        return require("private-next-pages/account/subscription.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/subscription"])
      });
    }
  